import React, { Component } from 'react';

import ContentCollection from 'Components/ContentCollection';

class ContentCollections extends Component {
  render() {
    const { lists } = this.props;
    if (!lists || lists.length === 0) return null;

    return (
      <div className="ContentCollections">
        {this.props.lists.map((collection, i) => (
          <ContentCollection key={collection.listId} {...collection} />
        ))}
      </div>
    );
  }
}

export default ContentCollections;
